export const Home = () => import(/* webpackChunkName: "Home" */ './../views/Home.vue')
export const PageNotFound = () => import(/* webpackChunkName: "PageNotFound" */ './../views/PageNotFound.vue')
export const ComingSoon = () => import(/* webpackChunkName: "ComingSoon" */ '@/views/ComingSoon')
export const ContactUs = () => import(/* webpackChunkName: "ContactUs" */ '@/views/ContactUs')
export const EatDrink = () => import(/* webpackChunkName: "Events" */ '@/views/EatDrink')
export const Events = () => import(/* webpackChunkName: "Events" */ '@/views/Events')
export const Faq = () => import(/* webpackChunkName: "Faq" */ '@/views/Faq')
export const PrivateBooking = () => import(/* webpackChunkName: "PrivateBooking" */ '@/views/PrivateBooking')
export const EventInquiry = () => import(/* webpackChunkName: "EventInquiry" */ '@/views/EventInquiry')
export const Offers = () => import(/* webpackChunkName: "Offers" */ '@/views/Offers')
export const OfferDetail = () => import(/* webpackChunkName: "OfferDetail" */ '@/views/OfferDetail')
export const RestaurantDetail = () => import(/* webpackChunkName: "RestaurantDetail" */ '@/views/RestaurantDetail')
export const EventDetail = () => import(/* webpackChunkName: "EventDetail" */ '@/views/EventDetail')
export const Pages = () => import(/* webpackChunkName: "EventDetail" */ '@/views/Pages')
export const RoomPages = () => import(/* webpackChunkName: "EventDetail" */ '@/views/RoomPages')

export default {
  Home,
  ComingSoon,
  ContactUs,
  EatDrink,
  Events,
  Faq,
  PrivateBooking,
  EventInquiry,
  Offers,
  OfferDetail,
  RestaurantDetail,
  EventDetail,
  Pages,
  RoomPages,
}
